export default class Attachment {
    constructor(dto) {
        this.id = -1;
        this.documentId = -1;
        this.description = '';
        this.fileId = '';
        this.fileName = '';

        if (dto) {
            this.id = dto.Id;
            this.description = dto.Description;
            this.documentId = dto.ObjectID;
            this.fileName = dto.Description;
        }
    }

    toDto() {
        return {
            Id: this.id,
            ObjectID: this.documentId,
            Description: this.description,
            FileID: this.fileId,
            FileName: this.name,
        };
    }
}
